var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoldura(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 318.49,
    height: 196.75,
    viewBox: "0 0 318.49 196.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        stroke: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #707070;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_1964",
    "data-name": "Path 1964"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 0.4999921917915344 196.2006683349609 L 0.4999921917915344 0.4999988079071045 L 182.2678833007812 0.4999988079071045 L 317.5109252929688 166.5292205810547 L 0.4999921917915344 196.2006683349609 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M 1 1 L 1 195.6516723632812 L 316.5316467285156 166.1186370849609 L 182.0302886962891 1 L 1 1 M 0 0 L 182.5054931640625 0 L 318.490234375 166.9397125244141 L 0 196.7496643066406 L 0 0 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoldura);
export default __webpack_public_path__ + "static/media/Moldura.392a1c11d186f544a4df4e942bae84fc.svg";
export { ForwardRef as ReactComponent };